import { ref } from 'vue';

type TToastVariant = 'success' | 'error';

type TToast = {
  id: number;
  message: string;
  variant: TToastVariant;
};

const toasts = ref<TToast[]>([]);
let nextId = 0;

type TShowOptions = {
  message: string;
  duration?: number;
};

function showToast(message: string, variant: TToastVariant, duration = 3000) {
  const id = nextId++;
  toasts.value.push({ id, message, variant });
  setTimeout(() => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }, duration);
}

export function useToast() {
  function success({ message, duration = 3000 }: TShowOptions) {
    showToast(message, 'success', duration);
  }

  function error({ message, duration = 3000 }: TShowOptions) {
    showToast(message, 'error', duration);
  }

  return { toasts, success, error };
}
